// import components
import { styled } from '@mui/material';
import { Dialog } from 'components/shared';

export const StyledPlanningCycleDialog = styled(Dialog)(() => ({
  '& .MuiDialogContent-root': {
    minWidth: '500px'
  }
}));
